"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOut = void 0;
var react_1 = __importStar(require("react"));
var aws_amplify_1 = __importStar(require("aws-amplify"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var SignIn_1 = __importDefault(require("./SignIn"));
var aws_exports_1 = __importStar(require("./aws-exports"));
var AuthenticatorContext_1 = __importDefault(require("./AuthenticatorContext"));
var react_ui_1 = require("@sport-thieme/react-ui");
var PermissionContextProvider_1 = __importDefault(require("./Permission/PermissionContextProvider"));
var aws_exports_2 = __importDefault(require("./aws-exports"));
var CognitoSyncContextProvider_1 = __importDefault(require("./CognitoSyncContextProvider"));
var MaintenanceModeProvider_1 = __importDefault(require("./MaintenanceMode/MaintenanceModeProvider"));
var Authenticator = function (_a) {
    var children = _a.children, amplifyConfig = _a.amplifyConfig, logHubEvents = _a.logHubEvents;
    var elements = null;
    var _b = (0, react_1.useState)(initialAuthState), auth = _b[0], setAuth = _b[1];
    var _c = (0, react_1.useState)('mounting'), authState = _c[0], setAuthState = _c[1];
    var handleAuthState = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cookieRedirectKey, cookieRedirecValue, cookieStorage, _a, hostname, href, user, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cookieRedirectKey = 'SportThieme.url';
                    cookieRedirecValue = js_cookie_1.default.get(cookieRedirectKey);
                    cookieStorage = aws_exports_1.default.Auth.cookieStorage;
                    _a = window.location, hostname = _a.hostname, href = _a.href;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, aws_amplify_1.Auth.currentAuthenticatedUser()];
                case 2:
                    user = _b.sent();
                    if (cookieRedirecValue) {
                        js_cookie_1.default.remove(cookieRedirectKey, cookieStorage);
                        window.location.href = cookieRedirecValue;
                    }
                    else {
                        setAuth(__assign(__assign({}, auth), { user: user }));
                        setAuthState('signedIn');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    if (process.env.NODE_ENV === 'production' &&
                        process.env.REACT_APP_AUTH_LOCAL !== 'true' &&
                        hostname !== aws_exports_1.SPORT_THIEME_DOMAIN) {
                        if (!cookieRedirecValue) {
                            js_cookie_1.default.set(cookieRedirectKey, href, cookieStorage);
                        }
                        window.location.href = "//" + aws_exports_1.SPORT_THIEME_DOMAIN;
                    }
                    else {
                        setAuthState('signIn');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // configuration
    (0, react_1.useEffect)(function () {
        var configToApply = process.env.NODE_ENV === 'development' ? {} : amplifyConfig;
        aws_amplify_1.default.configure(__assign(__assign({}, aws_exports_1.default), configToApply));
    }, []);
    // setup Hub hook
    (0, react_1.useEffect)(function () {
        var listener = function (_a) {
            var payload = _a.payload;
            if (logHubEvents === true)
                console.log('hub-event', payload);
            switch (payload.event) {
                case 'signIn':
                    handleAuthState();
                    break;
                case 'signIn_failure':
                    setAuthState('signIn');
                    break;
                case 'signOut':
                    setAuthState('signIn');
                    break;
                default:
                    break;
            }
        };
        aws_amplify_1.Hub.listen('auth', listener);
        return function () { return aws_amplify_1.Hub.remove('auth', listener); };
    }, []);
    // check currentUser hook
    (0, react_1.useEffect)(function () {
        handleAuthState();
    }, []);
    // refresh token hook
    (0, react_1.useEffect)(function () {
        if (auth.user === undefined)
            return;
        var interval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            var cognitoUser_1, session, error_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(((_b = (_a = auth.user) === null || _a === void 0 ? void 0 : _a.getSignInUserSession()) === null || _b === void 0 ? void 0 : _b.isValid()) === false)) return [3 /*break*/, 5];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, aws_amplify_1.Auth.currentAuthenticatedUser()];
                    case 2:
                        cognitoUser_1 = _c.sent();
                        return [4 /*yield*/, aws_amplify_1.Auth.currentSession()];
                    case 3:
                        session = _c.sent();
                        cognitoUser_1.refreshSession(session.getRefreshToken(), function (err, newSession) {
                            if (err) {
                            }
                            else {
                                cognitoUser_1.setSignInUserSession(newSession);
                                setAuth(__assign(__assign({}, auth), { user: cognitoUser_1 }));
                            }
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _c.sent();
                        console.log({ error: error_2 });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }, 1000);
        return function () { return clearInterval(interval); };
    }, [auth]);
    /**
     * rendering logic
     */
    if (authState === 'mounting') {
        elements = react_1.default.createElement(react_ui_1.PagePreloader, null);
    }
    if (authState === 'signIn') {
        elements = react_1.default.createElement(SignIn_1.default, null);
    }
    if (authState === 'signedIn') {
        elements = react_1.default.createElement(MaintenanceModeProvider_1.default, null, children);
    }
    return (react_1.default.createElement(AuthenticatorContext_1.default.Provider, { value: auth },
        react_1.default.createElement(CognitoSyncContextProvider_1.default, null,
            react_1.default.createElement(PermissionContextProvider_1.default, null, elements))));
};
var signOut = function () { return aws_amplify_1.Auth.signOut(); };
exports.signOut = signOut;
exports.default = Authenticator;
var initialAuthState = {
    signOut: function () { return aws_amplify_1.Auth.signOut({ global: true }); },
    user: undefined,
    identityPoolId: aws_exports_2.default.Auth.identityPoolId,
};
//# sourceMappingURL=Authenticator.js.map